import { gsap } from 'gsap';
import jQuery from "jquery";
import { PageHandler } from './PageHandler';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import { Utils } from '../misc/Utils';
import imagesLoaded from 'imagesloaded';

export class SingleServicePageHandler extends PageHandler {
    constructor(id) {
    	super(id);
        this.mainElemId = "services"
    }


    init() {
		this.events();
    }

    ajax() {
	
	}

    destroy() {
    
    }

	events() {
		
	}

	transitions() {
		imagesLoaded(document.querySelector('.section-content__pane .pane-image'), function (instance) {
			Utils.fadeInFrom('.psychological-service .pane-image');
		})
		Utils.fadeInUp('.psychological-service .section-content .section-content__pane');
	}
}